module.exports = __webpack_public_path__ + "static/media/Hair_3_green.936bf09f.svg";